<div class="overlay" [ngClass]="[
    localized ? 'overlayLocalized appearing' : 'overlayFullScreen', 
    onContent ? 'localizedOnContent' : 'localizedOnDiv', 
    isDarkActive ? 'loaderBGDark' : 'loaderBGLight', 
    disappearCondition ? (disappearing ? 'disappearingLoader' : 'disappearedLoader') : ''
]"  [style.border-radius]="localized ? borderRadius : null">
    <mat-progress-spinner class="spinner" color="primary" mode="indeterminate"
        [diameter]="localized ? 40 : 100" value="50"></mat-progress-spinner>
</div>
